import React, { useMemo } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { FiTrendingUp } from "react-icons/fi";
import "../../containers/SpAndSuAnalysis/style.css";

// 🔹 Custom Tooltip Component
const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div
                style={{
                    background: "white",
                    border: "1px solid #e2e8f0",
                    borderRadius: 8,
                    padding: "8px 12px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
            >
                <p style={{ margin: 0, fontWeight: 600 }}>{label}</p>
                <p style={{ margin: 0, color: "#475569" }}>
                    Bookings: <span style={{ fontWeight: 600 }}>{payload[0].value}</span>
                </p>
            </div>
        );
    }
    return null;
};

// 🔹 Custom Legend Component
const CustomLegend = ({ color }) => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div
            style={{
                width: 16,
                height: 4,
                borderRadius: 2,
                backgroundColor: color,
                marginTop: '10px'
            }}
        />
        <span style={{ fontSize: 14, color: "#475569", marginTop: '10px' }}>
            Bookings <span style={{ color: "#94a3b8" }}>(hover to see values)</span>
        </span>
    </div>
);

// 🔹 Custom Bar Shape for 0 values
const CustomBarShape = (props) => {
    const { x, y, width, height, value, fill } = props;
    const minHeight = 3; // minimal height for zero bars
    const adjustedHeight = value === 0 ? minHeight : height;
    const adjustedY = value === 0 ? y - (minHeight - height) : y;

    return (
        <rect
            x={x}
            y={adjustedY}
            width={width}
            height={adjustedHeight}
            fill={fill}
            rx={4}
            ry={4}
        />
    );
};

const BookingBarChart = ({ data, color = "#3B82F6" }) => {
    // 🔹 Prepare data for recharts
    const chartData = useMemo(() => {
        if (!data?.labels || !data?.data) return [];
        return data.labels.map((label, i) => ({
            label,
            value: data.data[i] ?? 0,
        }));
    }, [data]);

    return (
        <div className="chart-card">
            <div className="chart-header">
                <div className="chart-header-left">
                    <FiTrendingUp className="chart-icon" size={20} />
                    <h3 className="chart-title">Bookings Trends - Bar Chart</h3>
                </div>
            </div>


            <ResponsiveContainer width="100%" height={320} className="bookings-trend-barChart-Container">
                <BarChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis
                        dataKey="label"
                        tick={{ fontSize: 12, fill: "#555" }}
                        axisLine={false}
                        tickLine={false}
                    />
                    <YAxis
                        tick={{ fontSize: 12, fill: "#555" }}
                        axisLine={false}
                        tickLine={false}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar
                        dataKey="value"
                        fill={color}
                        name="Booking"
                        radius={[4, 4, 0, 0]}
                        shape={<CustomBarShape />}
                    />
                </BarChart>
            </ResponsiveContainer>
            <div className="custom-legend-container">
                <CustomLegend color={color} />
            </div>
        </div>
    );
};

export default BookingBarChart;
